export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_RESET = "AUTH_RESET";
export const AUTH_SET = "AUTH_SET";
export const AUTH_UPDATE = "AUTH_UPDATE";
export const AUTH_LOGIN = "AUTH_LOGIN";
export const AUTH_LOADING = "AUTH_LOADING";
export const AUTH_SIGNUP = "AUTH_SIGNUP";
export const AUTH_LOGIN_SUCCESS = "AUTH_LOGIN_SUCCESS";
export const AUTH_LOGIN_FAILURE = "AUTH_LOGIN_FAILURE";
export const AUTH_SET_LOADING = "AUTH_SET_LOADING";
export const AUTH_SET_ERROR = "AUTH_SET_ERROR";
export const AUTH_ERROR = "AUTH_ERROR";
export const AUTH_SIGNOUT_FAILURE = "AUTH_SIGNOUT_FAILURE";

export const USER_FETCH_SUCCESS = "USER_FETCH_SUCCESS";
export const USER_UPDATE = "USER_UPDATE";
export const USER_RESET = "USER_RESET";
export const USER_SET = "USER_SET";
export const USER_CREATE_SUCCESS = "USER_CREATE_SUCCESS";
export const USER_CREATE = "USER_CREATE";
export const USER_CREATE_FAILURE = "USER_CREATE_FAILURE";

export const CALLS_FETCH = "CALLS_FETCH";
export const CALLS_FETCH_SUCCESS = "CALLS_FETCH_SUCCESS";
export const CALLS_FETCH_FAILURE = "CALLS_FETCH_FAILURE";
export const CALLS_RESET = "CALLS_RESET";
export const CALLS_SET = "CALLS_SET";
export const CALLS_SELECTION_SET = "CALLS_SELECTION_SET";
export const CALLS_DEEPLINK_FETCH = "CALLS_DEEPLINK_FETCH";
export const CALLS_DEEPLINK_FETCH_SUCCESS = "CALLS_DEEPLINK_FETCH_SUCCESS";
export const CALLS_DEEPLINK_FETCH_FAILURE = "CALLS_DEEPLINK_FETCH_FAILURE";

export const ALGOLIA_FETCH = "ALGOLIA_FETCH";
export const ALGOLIA_FETCH_SUCCESS = "ALGOLIA_FETCH_SUCCESS";
export const ALGOLIA_FETCH_FAILURE = "ALGOLIA_FETCH_FAILURE";

export const OPERATORS_FETCH = "OPERATORS_FETCH";
export const OPERATORS_FETCH_SUCCESS = "OPERATORS_FETCH_SUCCESS";
export const OPERATORS_FETCH_FAILURE = "OPERATORS_FETCH_FAILURE";
export const OPERATORS_RESET = "OPERATORS_RESET";
export const OPERATORS_SET = "OPERATORS_SET";

export const ANALYTICS_INIT_FETCH_SUCCESS = "ANALYTICS_INIT_FETCH_SUCCESS";
export const ANALYTICS_FETCH = "ANALYTICS_FETCH";
export const ANALYTICS_FETCH_SUCCESS = "ANALYTICS_FETCH_SUCCESS";
export const ANALYTICS_FETCH_FAILURE = "ANALYTICS_FETCH_FAILURE";
export const ANALYTICS_RESET = "ANALYTICS_RESET";
export const ANALYTICS_SET = "ANALYTICS_SET";
export const ANALTYCS_LOADING = "ANALTYCS_LOADING";
export const ANALTYCS_LOADING_DONE = "ANALTYCS_LOADING_DONE";

export const FINANCIAL_INSIGHTS_INIT_FETCH_SUCCESS = "FINANCIAL_INSIGHTS_INIT_FETCH_SUCCESS";
export const FINANCIAL_INSIGHTS_FETCH = "FINANCIAL_INSIGHTS_FETCH";
export const FINANCIAL_INSIGHTS_FETCH_SUCCESS = "FINANCIAL_INSIGHTS_FETCH_SUCCESS";
export const FINANCIAL_INSIGHTS_FETCH_FAILURE = "FINANCIAL_INSIGHTS_FETCH_FAILURE";
export const FINANCIAL_INSIGHTS_RESET = "FINANCIAL_INSIGHTS_RESET";
export const FINANCIAL_INSIGHTS_SET = "FINANCIAL_INSIGHTS_SET";
export const FINANCIAL_INSIGHTS_LOADING = "FINANCIAL_INSIGHTS_LOADING";
export const FINANCIAL_INSIGHTS_LOADING_DONE = "FINANCIAL_INSIGHTS_LOADING_DONE";

export const FINANCIAL_DETAIL_FETCH = "FINANCIAL_DETAIL_FETCH";
export const FINANCIAL_DETAIL_FETCH_SUCCESS = "FINANCIAL_DETAIL_FETCH_SUCCESS";
export const FINANCIAL_DETAIL_FETCH_FAILURE = "FINANCIAL_DETAIL_FETCH_FAILURE";
export const FINANCIAL_DETAIL_RESET = "FINANCIAL_DETAIL_RESET";
export const FINANCIAL_DETAIL_SET = "FINANCIAL_DETAIL_SET";

export const LISTS_FETCH = "LISTS_FETCH";
export const LISTS_FETCH_SUCCESS = "LISTS_FETCH_SUCCESS";
export const LISTS_FETCH_FAILURE = "LISTS_FETCH_FAILURE";
export const LIST_DATA_FETCH = "LIST_DATA_FETCH";
export const LIST_DATA_FETCH_SUCCESS = "LIST_DATA_FETCH_SUCCESS";
export const LIST_DATA_FETCH_FAILURE = "LIST_DATA_FETCH_FAILURE";

export const DEBRIEFS_FETCH = "DEBRIEFS_FETCH";
export const DEBRIEFS_FETCH_SUCCESS = "DEBRIEFS_FETCH_SUCCESS";
export const DEBRIEFS_FETCH_FAILURE = "DEBRIEFS_FETCH_FAILURE";
export const DEBRIEF_FETCH = "DEBRIEF_FETCH";
export const DEBRIEF_FETCH_SUCCESS = "DEBRIEF_FETCH_SUCCESS";
export const DEBRIEF_FETCH_FAILURE = "DEBRIEF_FETCH_FAILURE";
export const OBJECTIVES_FETCH = "OBJECTIVES_FETCH";
export const OBJECTIVES_FETCH_SUCCESS = "OBJECTIVES_FETCH_SUCCESS";
export const OBJECTIVES_FETCH_FAILURE = "OBJECTIVES_FETCH_FAILURE";
